import  { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';

const CertificateGenerator = () => {
  
    const [marginLeft, setMarginLeft] = useState(
      window.innerWidth > 768 ? '300px' : '0px'
    );
  
    useEffect(() => {
      const handleResize = () => {
        setMarginLeft(window.innerWidth > 768 ? '270px' : '0px');
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  const [formData, setFormData] = useState({
    name: '',
    courseName: '',
    certificateId: ''
  });
  const [showCertificate, setShowCertificate] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  return (
     <>
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
                .certificate-id{
                margin-left:-2rem;
              }
                .title-underline {
    display: block !important;
    height: 3px !important;
    background-color: #4a6da7 !important;
    margin: 10px auto !important;
      border-bottom: 4px solid #4a6da7;
  }

            .certificate-printable, .certificate-printable * {
              visibility: visible;
            }
            .certificate-printable {
              position: absolute;
              left: 0;
              top: -1.6rem;
              width: 100%;
              height: 100%;
              margin: 0;
              padding: 0;
            }
            
            @page {
              size: auto;
              margin: 0mm;
            }
          }
          .certificate-wrapper {
            max-width: 1200px;
            margin: 0 auto;
            //  width: 100%;
            // height: 100%;
            // overflowX:hidden;
            position: relative;
          }
          .certificate-border {
            background-color: white;
            border: 30px solid #4a6da7;
            position: relative;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
          }
          .corner {
            position: absolute;
            width: 50px;
            height: 50px;
          }
          .corner-tl {
            top: -3px;
            left: -5px;
          }
          .corner-tr {
            top: -5px;
            right: -5px;
            transform: rotate(90deg);
          }
          .corner-bl {
            bottom: -5px;
            left: -5px;
            transform: rotate(270deg);
          }
          .corner-br {
            bottom: -5px;
            right: -5px;
            transform: rotate(180deg);
          }
          .certificate-title {
            font-family: 'Times New Roman', serif;
            font-weight: bold;
            color: #2c3e50;
            font-size: 2.5rem;
            position: relative;
            display: inline-block;
          }
          .title-underline {
            width: 100px;
            height: 3px;
            background-color: #4a6da7;
            margin: 10px auto;
          }
          .student-name {
            // font-family: 'Brush Script MT', cursive;
            font-family: 'Lora', serif;
            font-weight: bold;
            font-size: 2.5rem;
            color: #2c3e50;
            margin: 1rem 0;
            position: relative;
            display: inline-block;
          }

           .student-name::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 2px;
            background: linear-gradient(90deg, transparent, #4a6da7, transparent);
    display: block;
    visibility: visible;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  
          .certificate-description {
            max-width: 700px;
            font-size: 1.6rem;
            line-height: 1.6;
          }
          .detail-item {
            margin-bottom: 0.5rem;
            
          }
          // .detail-label {
          //   font-weight: bold;
          //   margin-left: -3rem;
          // }
          .signature-line {
            width: 200px;
            height: 1px;
            background-color: #333;
            margin: 0 auto;
          }
          .signature-name {
            font-weight: bold;
            margin-top: -5px;
          }
            
          .institution-logo img {
            border-radius: 50%;
            // border: 2px solid #4a6da7;
            // padding: 5px;
          }
          .print-button {
            background-color: #2c3e50;
            border: none;
            padding: 10px 25px;
            font-weight: bold;
          }
          .print-button:hover {
            background-color: #1a252f;
          }
          @media (max-width: 768px) {
            .certificate-title {
              font-size: 2rem;
            }
            .student-name {
              font-size: 2.5rem;
            }
            .certificate-border {
              border-width: 10px;
            }
            .corner {
              width: 40px;
              height: 40px;
            }
          }
          @media (max-width: 576px) {
            .certificate-title {
              font-size: 1.8rem;
            }
            .student-name {
              font-size: 2rem;
            }
            .certificate-description {
              font-size: 1rem;
            }
            .signature-line {
              width: 150px;
            }
          }
 
/* Apply label above value */
.certificate-id-block {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

/* Bold label */
.certificate-label {
  font-weight: bold !important;
  font-size: 1.1rem;
}

/* Print only */
@media print {
  .certificate-id {
    display: block !important;
    // margin-top: 1rem;
    margin-bottom: 2rem;
  }
}

        `}
      </style>

      <div style={{ marginLeft }}>
        {/* Non-printable controls */}
        <div className="no-print">
          <div className="container-fluid p-0"
            style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}>
            <div className="p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white" style={{backgroundColor:"#4a6da7"}}>
              <h2 className="m-0">Generate Certificate</h2>
            </div>
          </div>

          <Row className="g-2 align-items-end d-flex mt-3 flex-wrap">
            <Col md={3}>     
              <Form.Group className="mb-3 text-start fw-bold" controlId="name">
              <Form.Label>Student Name</Form.Label>
              <Form.Control
               type="text"
               className="form-control"
               id="name"
               name="name"
               placeholder="Full Name"
               value={formData.name}
               onChange={handleChange}
               required
              />
            </Form.Group>
            </Col>
            <Col md={3}>     
              <Form.Group className="mb-3 text-start fw-bold" controlId="name">
              <Form.Label>Course Name</Form.Label>
              <Form.Control
             type="text"
             className="form-control"
             id="courseName"
             name="courseName"
             placeholder="Course Name"
             value={formData.courseName}
             onChange={handleChange}
             required
              />
            </Form.Group>
            </Col>
            <Col md={3}>     
              <Form.Group className="mb-3 text-start fw-bold" controlId="name">
              <Form.Label>Certificate ID</Form.Label>
              <Form.Control
               type="text"
               className="form-control"
               id="certificateId"
               name="certificateId"
               placeholder="Certificate ID"
               value={formData.certificateId}
               onChange={handleChange}
               required
              />
            </Form.Group>
            </Col>
            <Col className="d-flex justify-content-start align-items-center" >
              <Button
                variant="outline"
                title="Refresh"
                className="text-white" 
                style={{backgroundColor:"#4a6da7", marginBottom:"1rem"}}
                onClick={()=>setShowCertificate(true)}
              >
                <FaEye /> View Certificate
              </Button>
            </Col>
           {showCertificate &&  (
             <Col md="auto">
             <Button 
                // variant='outline-success'
               className="btn btn-success print-button"
               style={{marginBottom:".7rem"}}
               onClick={() => window.print()}
             >
               Print Certificate
             </Button>
           </Col>
           )}
          </Row>
        </div>

    { showCertificate && (
          <div className="certificate-printable">
          <div className="certificate-wrapper mt-4">
            <div className="certificate-border">
              <div className="corner corner-tl"></div>
              <div className="corner corner-tr"></div>
              <div className="corner corner-bl"></div>
              <div className="corner corner-br"></div>
              
              <div className="certificate-content p-4 p-md-5"
              //  style={{lineHeight: '2.7'}}
              >
                <div className="text-center mb-4" >
                  <div className="institution-logo mb-3" style={{ marginTop:"35px" }}>
                    <img 
                      src="/vivekanandji_logo.jpg" 
                      alt="Institution Logo" 
                      className="img-fluid"
                      style={{ width: '170px', height: '170px' }}
                    />
                  </div>
                  <h3 className="text-uppercase mb-0">VIVEKANANDA INSTITUTE OF COMPUTER SCIENCE</h3>
                </div>
                
                <div className="text-center mb-4" style={{ marginTop: '47px' }}>
                  <h1 className="certificate-title mb-0">Certificate of Completion</h1>
                  <div className="title-underline mx-auto" style={{marginTop:"20px"}}></div>
                  <p>This Certificate is Awarded To</p>
                </div>
                
                <div className="text-center mb-2">
                  <h2 className="student-name">{formData?.name}</h2>
                </div>
                
                <div className="text-center ">
                  <p className="certificate-description mx-auto" style={{ marginBottom: '63px', marginTop: '40px', lineHeight: '2.1' }}>
                  This certificate is awarded in recognition of the successful completion in the specified course.
                  </p>
                </div>
                
                <div className="certificate-details row" style={{ marginBottom: '50px' }}>
  <div className="col-md-4 mb-3">
    <div className="detail-item">
       <span className="detail-label fw-bold">Date of Completion:</span>
      {/* <span className="detail-value">{new Date().toLocaleDateString()}</span> */}
     
    </div>
  </div>
  
  <div className="col-md-4 text-center" style={{marginTop:"4rem", }}>
    <div className="detail-item">
       <span className="detail-label fw-bold">Course:</span>
      <div><span className="detail-value">{formData?.courseName}</span></div>
    </div>
  </div>
  {/* Certificate ID Block */}
{/* <div className="col-12 text-end certificate-id d-print-block d-none" style={{ marginBottom: '2rem' }}>
  <div className="certificate-id-block">
    <div className="certificate-label">Certificate ID:</div>
    <div className="certificate-value">{formData.certificateId}</div>
  </div>
</div> */}

  <div className="col-md-4 mb-3 text-end certificate-id ">
    <div className="detail-item">
      <span className="detail-label fw-bold">Certificate ID: </span>
      <span className="detail-value">{formData.certificateId}</span>
    </div>
  </div>
                  </div>
                
                <div className="row signatures mt-5"  style={{marginTop:"2rem"}}>
                  <div className="col-md-6 text-center mb-3 mb-md-0" >
                    <div className="signature-line mb-1"></div>
                    <p className="mb-0">Instructor</p>
                    <p className="signature-name">Authorized Signatory</p>
                  </div>
                  <div className="col-md-6 text-center">
                    <div className="signature-line mb-1"></div>
                    <p className="mb-0"></p><br/>
                    <p className="signature-name">Authorized Signatory</p>
                  </div>
                </div>
                
                <div className="text-center mt-4">
                  <p className="footer-text mb-0">
                    {/* <small>This certificate is verifiable at www.shrihitgyanwati.vibhumsoftware.com/.edu/verify</small> */}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
    )}
      </div>
    </>
  );
};

export default CertificateGenerator;